module.exports = __webpack_public_path__ + "./images/use.1e8cfd.jpg";